export default __webpack_public_path__ + "static/media/info-filled.5facfe65.svg";